import { SVGProps } from 'react';

/** Aerials radar icon. Uses `currentColor`. */
export const AerialsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    // `width`/`height` after `{...props}` so it renders 1px larger than
    // its neighbours (19×19 vs. 18×18) regardless of what the caller passes.
    <svg
      data-icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
      width="19"
      height="19"
    >
      {/* Outer radar boundary */}
      <circle cx="12" cy="12" r="9" />
      {/* Inner ring for the concentric-radar feel */}
      <circle cx="12" cy="12" r="5" />
      {/* Sweep line from centre out to the outer ring, angled NE */}
      <line x1="12" y1="12" x2="18.36" y2="5.64" />
      {/* Centre dot — filled to read as a point of origin */}
      <circle cx="12" cy="12" r="1.25" fill="currentColor" stroke="none" />
    </svg>
  );
};
